<template>
<v-layout row wrap >
  <v-flex xs12 sm4 class='pa-0' style='border-left:solid 1px #ccc;'
    v-for='step in steps' :key='step.id' >
    <slot :name='`step-${step.id}`' ></slot>
  </v-flex>
</v-layout>
</template>
<script>
export default {
  name: 'HomeRelationships',
  props: {
    steps: { type: Array, default: () => { return [{id: 0}, {id: 1}, {id: 2}] } },
    initialStep: { type: Number, default: 0 }
  }
}
</script>



// WEBPACK FOOTER //
// StepLayout.vue?e2c618e4